import theme from '@services/theme'

export default {
    colors: theme.palette.Tag
}